import { getIframeSettings } from '../hooks/useIframeSettings';
import { trace } from 'owa-trace';
import type { FrameInfoV2 } from '@microsoft/wv2-outlook/instanceIframeTracker';
import { iframesMapping, type IframeScenario } from '../settings/iframes-mapping';

/**
 * Determines the scenario from an iframe source URL by matching against known scenario URL patterns.
 * "Unknown" if no match, used for pooling uncategorized iframes.
 * @param iframeSource The URL/source of the iframe
 * @returns The matching IframeScenario or 'Unknown' if no match is found
 */
export function getScenarioFromIframeSource(iframeSource: string): IframeScenario | 'Unknown' {
    for (const [scenario, settings] of Object.entries(iframesMapping)) {
        if (settings.matchUrl(iframeSource)) {
            return scenario as IframeScenario;
        }
    }
    trace.warn(
        `No matching scenario for iframe source: ${iframeSource}. Using "Unknown"`,
        'iframeWrapper'
    );
    return 'Unknown';
}

/**
 * Filters a list of FrameInfos to only include those matching the given scenario.
 * @param scenario The scenario to filter by
 * @param iframes The list of FrameInfos to filter
 * @returns The filtered list of FrameInfos matching the scenario
 */
export function getIframesForScenarioV2(
    scenario: IframeScenario,
    iframes: FrameInfoV2[] | undefined
): FrameInfoV2[] | undefined {
    const { matchUrl } = getIframeSettings(scenario);
    const matchedIframes = iframes?.filter(iframe => matchUrl(iframe.iframeSource));

    return matchedIframes;
}
